import React from 'react';

const heroImage = 'https://assets.auxodev.dk/assets/b7fb5f15-602f-4c3f-8819-ccd847432aa9/imgi-39-489427526-1218920886598683-6098105218074926481-n.jpg';
const cdnImage = (width) => `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=82,format=auto/assets/b7fb5f15-602f-4c3f-8819-ccd847432aa9/imgi-39-489427526-1218920886598683-6098105218074926481-n.jpg`;

export function SubpageHero({ eyebrow = 'JNO Montage', title, description }) {
  return (
    <section className="relative isolate min-h-[330px] overflow-hidden text-white sm:min-h-[380px] lg:min-h-[540px]">
      <img
        src={cdnImage(1600)}
        srcSet={`${cdnImage(800)} 800w, ${cdnImage(1200)} 1200w, ${cdnImage(1800)} 1800w`}
        sizes="100vw"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-[#0B0E14]/75" />
      <div className="relative mx-auto flex min-h-[330px] max-w-[1280px] items-center px-5 sm:min-h-[380px] sm:px-8 lg:min-h-[540px] lg:px-12">
        <div className="max-w-4xl">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-white">{eyebrow}</p>
          <h1 className="mt-4 text-3xl font-semibold leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">{title}</h1>
          {description && <p className="mt-5 max-w-2xl text-base leading-7 text-white/85 sm:text-lg">{description}</p>}
        </div>
      </div>
    </section>
  );
}

export { heroImage };
